// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"377b2be0","239":"4f4d4541","732":"65d896dd"}[chunkId] + ".chunk.js";
};